export default [{
  path: '/candidates',
  name: 'candidates',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/candidates/index')
}]
